import React from 'react';
import { mainGuide } from '../data/resources';
import { guideInteriorPages } from '../data/pendingContent';
const topics = [{
  title: 'Choisir et préparer le support',
  text: 'Reconnaître un support transparent adapté, le nettoyer et le préparer avant de commencer.'
}, {
  title: 'Placer le modèle',
  text: 'Positionner le modèle sous le support et le maintenir pour qu’il ne bouge pas pendant le tracé.'
}, {
  title: 'Tracer les contours',
  text: 'Tenir le cerne, doser la pression et fermer chaque zone pour accueillir la couleur.'
}, {
  title: 'Appliquer les couleurs',
  text: 'Déposer et répartir la peinture, puis respecter le séchage propre aux produits utilisés.'
}, {
  title: 'Repérer les erreurs courantes',
  text: 'Comprendre un débordement ou un contour interrompu, et savoir comment l’éviter la fois suivante.'
}];
export function MainGuide() {
  return <section aria-labelledby="guide-title" className="bg-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-128" data-mp="h5ondz8romlw">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-start" data-id="element-129" data-mp="h7hnswssealg">
        <div className="lg:col-span-5 lg:sticky lg:top-24" data-id="element-130" data-mp="3q2izk5ye1p60">
          <div className="rounded-[2rem] bg-sand overflow-hidden aspect-square shadow-soft" data-id="element-131" data-mp="3lybag7o0q779">
            <img src={mainGuide.image} alt={mainGuide.imageAlt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-132" data-mp="3sey7kv6l3o6" />
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-133" data-mp="379x6ftev8cp4">
          <p className="text-sm font-semibold text-coral-deep" data-id="element-134" data-mp="37ayhhxvvsz6u">Le guide principal</p>
          <h2 id="guide-title" className="mt-2 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal" data-id="element-135" data-mp="32c5405glh86o">
            Votre guide pour commencer
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-ink/80 max-w-xl" data-id="element-136" data-mp="3c8rqeyokk7at">
            <span className="font-semibold text-ink" data-id="element-137" data-mp="2ojfkc7ojgfcq">L’Atelier du Faux Vitrail</span>{' '}
            vous accompagne depuis la préparation du support jusqu’aux finitions :
            tracer des contours réguliers, appliquer la couleur, respecter le
            séchage propre à vos produits et éviter les erreurs les plus fréquentes.
          </p>

          <ol className="mt-10 border-t border-ink/10" data-id="element-138" data-mp="sezqavjpyxd6">
            {topics.map((t, i) => <li key={t.title} className="grid grid-cols-[2.5rem_1fr] gap-x-3 py-5 border-b border-ink/10" data-id="element-139" data-mp="x8c2g677pbp1" data-mpi={i}>
                <span className="font-serif text-xl font-semibold text-coral-deep leading-snug" data-id="element-140" data-mp="117kvt9ycb7k2">
                  {i + 1}
                </span>
                <div data-id="element-141" data-mp="9hor1ay383xq">
                  <h3 className="font-serif text-lg sm:text-xl font-semibold text-teal" data-id="element-142" data-mp="9h6ltotg6fdo">
                    {t.title}
                  </h3>
                  <p className="mt-1 text-base leading-relaxed text-ink/75" data-id="element-143" data-mp="dhyvgj68emah">{t.text}</p>
                </div>
              </li>)}
          </ol>

          {guideInteriorPages.length > 0 && <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-144" data-mp="1oxf7vpau4s39">
              {guideInteriorPages.map(page => <div key={page.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-sand shadow-soft" data-id="element-145" data-mp="1tw8j1b2ng709">
                  <img src={page.src} alt={page.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-146" data-mp="240yss34aoff1" />
                </div>)}
            </div>}
        </div>
      </div>
    </section>;
}